import { render } from "./KeyDiagnosticCharacteristicsPH1.vue?vue&type=template&id=69a4a72e"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__